import { render, staticRenderFns } from "./TopTop.vue?vue&type=template&id=379f1a1e&scoped=true"
import script from "./TopTop.vue?vue&type=script&lang=js"
export * from "./TopTop.vue?vue&type=script&lang=js"
import style0 from "./TopTop.vue?vue&type=style&index=0&id=379f1a1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f1a1e",
  null
  
)

export default component.exports